import React from 'react';
import { CURRENCY, FORMAT_NUMBER } from "../libs/utils/Const";
import moment from "moment";

const date = (value) => {
    let dateObj = new Date(value);
    dateObj.setMinutes(dateObj.getMinutes() + dateObj.getTimezoneOffset());
    return moment(dateObj).format("DD-MM-YYYY");
};

const renderTable = (header, body) => {
    return (
        <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                {header}
            </thead>
            <tbody>
                {body}
            </tbody>
        </table>
    );
};

const lMatType = {
    'T': 'Modelo',
    'S': 'Ventas',
    'P': 'Producción',
    'A': 'Conjunto'
};
const StatusOrder = {
    'C': 'Cancelado',
    'L': 'Cerrado',
    'P': 'Planificado',
    'R': 'Liberado'
}
const TypeOrderDoc = {
    'D': 'Desmontar',
    'P': 'Especial',
    'S': 'Estándar'
}
const OriginTypeDoc = {
    'M': 'Manual',
    'R': 'MRP',
    'S': 'Sales Order',
    'U': 'Upgrade'
}
const BasicStatus = {
    'O': 'Abierto',
    'C': 'Cerrado'
}


const renderHeader = (headers, checkbox) => {
    return (
        <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    value="second_checkbox"
                    onChange={(event) => checkbox.selectAll(event.target.checked)}
                />
            </td>
            {headers.map((header, index) => {
                if (header.value) {
                    return <td key={index}>{header.title}</td>;
                }
                return null;
            })}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
        </tr>
    );
};

export const renderTableProductTree = (headers, data, checkbox, openDocumentDetails) => {
    const header = renderHeader(headers, checkbox);

    const body = data.map((list, index) => (

        <tr key={index}>
            <td className="sticky-column">
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    checked={!!checkbox.data.get(index)}
                    onChange={() => checkbox.selectOne(index)}
                />
            </td>
            {headers[0].value && <td>{list.Code}</td>}
            {headers[1].value && <td className="text-center">{list.ItemName}</td>}
            {headers[2].value && <td className="text-center">{<td>{lMatType[list.TreeType] || ''}</td>}</td>}
            {headers[3].value && <td className="text-center">{Number(list.Qauntity).toFixed(2)}</td>}
            {headers[4].value && <td className="text-center">{list.ToWH}</td>}
            {headers[5].value && <td className="text-center">{list.ListName}</td>}
            {headers[6].value && <td className="text-center">{list.OcrName}</td>}
            {headers[7].value && <td className="text-center">{list.Price}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button
                    type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDocumentDetails(list)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt" />
                    Ver Detalles
                </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableProductionOrder = (headers, data, checkbox, openDocumentDetails) => {
    const header = renderHeader(headers, checkbox);
    const body = data.map((order, index) => (
        <tr key={index}>
            <td className="sticky-column">
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    checked={!!checkbox.data.get(index)}
                    onChange={() => checkbox.selectOne(index)}
                />
            </td>
            {headers[0].value && <td>{order.SeriesName}</td>}
            {headers[1].value && <td className="text-center">{StatusOrder[order.Status] || ''}</td>}
            {headers[2].value && <td className="text-center">{order.DocNum}</td>}
            {headers[3].value && <td className="text-center">{TypeOrderDoc[order.Type]}</td>}
            {headers[4].value && <td className="text-center">{OriginTypeDoc[order.OriginType]}</td>}
            {headers[5].value && <td className="text-center">{order.CardCode}</td>}
            {headers[6].value && <td className="text-center">{order.CardName}</td>}
            {headers[7].value && <td className="text-center">{order.ItemCode || ''}</td>}
            {headers[8].value && <td className="text-center">{order.ProdName || ''}</td>}
            {headers[9].value && <td className="text-center">{order.PlannedQty ?? ''}</td>}
            {headers[10].value && <td className="text-center">{moment(order.PostDate).format('DD-MM-YYYY')}</td>}
            {headers[11].value && <td className="text-center">{order.Warehouse || ''}</td>}
            {headers[12].value && <td className="text-center">{order.Comments}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button
                    type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDocumentDetails(order)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt" />
                    Ver Detalles
                </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableGoodsReceiptProd = (headers, data, checkbox, openDocumentDetails) => {
    const header = renderHeader(headers, checkbox);

    const body = data.map((register, index) => (
        <tr key={index}>
            <td className="sticky-column">
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    checked={!!checkbox.data.get(index)}
                    onChange={() => checkbox.selectOne(index)}
                />
            </td>
            {headers[0].value && <td className="text-center">{register?.SeriesName ?? ''}</td>}
            {headers[1].value && <td className="text-center">{BasicStatus[register?.DocStatus ?? ''] ?? ''}</td>}
            {headers[2].value && <td className="text-center">{register?.DocNum}</td>}
            {headers[3].value && <td className="text-center">{register?.DocDueDate ? moment(register?.DocDueDate).format('DD-MM-YYYY') : ''}</td>}
            {headers[4].value && <td className="text-center">{register?.Comments ?? ''}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button
                    type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDocumentDetails(register)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt" />
                    Ver Detalles
                </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableGoodsIssue = (headers, data, checkbox, openDocumentDetails) => {
    const header = renderHeader(headers, checkbox);

    const body = data.map((register, index) => (

        <tr key={index + "OIGE"}>
            <td className="sticky-column">
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    checked={!!checkbox.data.get(index)}
                    onChange={() => checkbox.selectOne(index)}
                />
            </td>
            {headers[0].value && <td className="text-left">{register?.SeriesName ?? ''}</td>}
            {headers[1].value && <td className="text-center">{BasicStatus[register?.DocStatus] ?? ''}</td>}
            {headers[2].value && <td className="text-center">{register?.DocNum ?? ''}</td>}
            {headers[3].value && <td className="text-center">{register?.DocDueDate ? moment(register?.DocDueDate).format('DD-MM-YYYY') : ''}</td>}
            {headers[4].value && <td className="text-center">{register?.DocTotal ?? ''}</td>}
            {headers[5].value && <td className="text-center">{register?.Comments ?? ''}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button
                    type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDocumentDetails(register)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt" />
                    Ver Detalles
                </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableProvConfAssistant = (headers, data, checkbox) => {
    const OWOR = data[0]?.table === 'OWOR';
    const OPRQ = data[0]?.table === 'OPRQ';
    
    const header = (
        <tr>
            {headers.map((header, index) => {
                if (header.value) {
                    return <td key={index} className="text-center">{index === 3 && OPRQ ? 'SOLICITANTE' : header.title}</td>;
                }
                return null;
            })}
        </tr>
    );

    const body = data.slice(1).map((register, index) => (
        <tr key={index}>
            {headers[0].value && <td className="text-center">{!OWOR ? register?.Series : register?.SeriesName}</td>}
            {headers[1].value && <td className="text-center font-weight-bold">{!OWOR ? BasicStatus[register.DocStatus] : StatusOrder[register.Status]}</td>}
            {headers[2].value && <td className="text-center">{register?.DocNum ?? ''}</td>}
            {headers[3].value && <td className="text-center">{!OPRQ ? register?.CardCode : register?.Requester}</td>}
            {headers[4].value && <td className="text-left">{!OPRQ ? register?.CardName : register?.ReqName}</td>}
            {headers[5].value && <td className="text-center">{date(register?.DocDate || register?.PostDate)}</td>}
            {headers[6].value && <td className="text-left">{register?.Comments ? register.Comments : 'No hay comentarios'}</td>}
            {headers[7].value && <td className="text-right font-weight-bold">{`${CURRENCY} ${FORMAT_NUMBER.new(register?.DocTotal)}`}</td>}

        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableRscMasterData = (headers, data, checkbox, openDocumentDetails) => {
    const activeHeaders = Array.isArray(headers) ? headers.filter(({value}) => value) : [];
    const header = renderHeader(activeHeaders, checkbox);

    const body = data.map((register, index) => (
        <tr key={index}>
            <td className="sticky-column text-center">
                <input type="checkbox" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
            </td>
            {activeHeaders.map(({title, field, format}) => <td key={`${index}-${title}`}> {format ? format(register[field], register) : register[field]} </td>)}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button className="btn botonCorrect" onClick={() => openDocumentDetails(register)} > <i className="far fa-file-alt mr-2" /> Ver Detalles </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};

export const renderTableRscCapacity = (headers, data, checkbox, openDocumentDetails) => {
    const header = renderHeader(headers, checkbox);

    const body = data.map((register, index) => (
        <tr key={index}>
            <td className="sticky-column text-center">
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id="cbox2"
                    checked={!!checkbox.data.get(index)}
                    onChange={() => checkbox.selectOne(index)} />
            </td>
            {headers[0].value && <td></td>}
            {headers[1].value && <td className="text-center"></td>}
            {headers[2].value && <td className="text-center"></td>}
            {headers[3].value && <td className="text-center"></td>}
            {headers[4].value && <td className="text-center"></td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                <button type="button" className="btn botonCorrect" onClick={() => openDocumentDetails({})} >
                    <i className="far fa-file-alt" />
                    Ver Detalles
                </button>
            </td>
        </tr>
    ));

    return renderTable(header, body);
};